import { trackLandingActivation } from '../../utils/landingExperimentAnalytics';
import axiosInstance from '../api';
import {
  Prisma,
  comps,
  listings,
  mlsListings,
  pricingOpinions,
  showings,
} from '@prisma/client';

export type listingsWithOpenHouses = Prisma.listingsGetPayload<{
  include: { openHouses: true };
}>;

export type listingsWithUploads = Prisma.listingsGetPayload<{
  include: { uploads: true; user: true };
}>;

export type listingsWithMlsListing = Prisma.listingsGetPayload<{
  include: { mlsListing: true };
}>;

export type listingsWithExtra = listingsWithUploads &
  listingsWithOpenHouses &
  listingsWithMlsListing & {
    comps: comps[];
    estimatedPrice: number;
    showings: showings[];
    pricingOpinion?: pricingOpinions | null;
  };

export interface listingsWithPricingOpinion extends listingsWithExtra {
  pricingOpinion: pricingOpinions;
}

interface PatchListingParams {
  id: string;
  data: Partial<listings>;
  notify?: boolean;
}

const listingsService = {
  find: async ({
    params,
  }: {
    params?: Prisma.listingsFindManyArgs;
  }): Promise<listingsWithUploads[]> => {
    const queryParams = params ? { query: JSON.stringify(params) } : undefined;
    const response = await axiosInstance.get('/listings', {
      params: queryParams,
    });
    return response.data;
  },
  get: async ({
    id,
    params,
  }: {
    id: string;
    params?: any;
  }): Promise<listingsWithExtra> => {
    const response = await axiosInstance.get(`/listings/${id}`, { params });
    return response.data;
  },
  patch: async ({
    id,
    data,
    notify = false,
  }: PatchListingParams): Promise<listings> => {
    const response = await axiosInstance.patch(`/listings/${id}`, data, {
      params: { notify },
    });
    return response.data;
  },
  create: async (data: Partial<listings>, buyer = false) => {
    const response = await axiosInstance.post('/listings', data, {
      params: { buyer },
    });
    trackLandingActivation(buyer ? 'buyer_home_added' : 'seller_listing_started');
    return response.data;
  },
  delete: async (id: string) => {
    const response = await axiosInstance.delete(`/listings/${id}`);
    return response.data;
  },
};

export default listingsService;
